import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { BaseDestroyable } from '@core/base-destroyable';
import { defaultIfEmpty, map, switchMap, take, tap } from 'rxjs';
import { IOSimPlusIntegrationService } from 'app/services/iosim-plus-integration/iosim-plus-integration.service';
import { OrderSimulationInfo, SimulationStatusEnum } from '@shared/iosim-plus/models/simulationStatus';
import { IOSimSimulationInfoQuery } from 'app/services/iosim-simulation.store/iosim-simulation-status-progress.query';

@Injectable({providedIn: 'root'})
export class GetIosimProgress extends BaseDestroyable implements ICommunicationEvent {
	constructor(private iosimSimulationInfoQuery: IOSimSimulationInfoQuery,
		private iosimPlusIntegrationService: IOSimPlusIntegrationService) {
        super();
    }
	
	get eventName(): string {
		return PlatformCommunicationEvents.GetIosimProgress;
	}

	async handleEvent(event: any, publishEventFunc: Function) {
		const orderId = event.data.orderId;
		const publisher = event.eventHeader.publisher;

		this.iosimPlusIntegrationService.getOrderSimulationInfo(orderId, event.data.companyId).pipe(
			switchMap((orderSimulationInfo: OrderSimulationInfo) => {
				return this.iosimSimulationInfoQuery.selectEntity(orderId).pipe(
					take(1),
					defaultIfEmpty(undefined),
					map(store => {
						if (!store?.progress) {
							return {
								expectedDuration: +(orderSimulationInfo?.expectedDuration ?? 0),
								simulationStatus: `${SimulationStatusEnum.NotStarted}`,
								startSimulationTime: 0,
								notSupportedScanDate: false,
								isQualifiedForIoSimPlus: orderSimulationInfo?.isQualifiedForIoSimPlus,
							};
						}
						return {
							expectedDuration: store.progress.expectedDuration || +(orderSimulationInfo?.expectedDuration ?? 0),
							simulationStatus: `${store.progress.simulationStatus || SimulationStatusEnum.NotStarted}`,
							startSimulationTime: store.progress.startSimulationTime ? new Date(store.progress.startSimulationTime).getTime() : 0,
							notSupportedScanDate: store.notSupportedScanDate ?? false,
							isQualifiedForIoSimPlus: orderSimulationInfo?.isQualifiedForIoSimPlus,
						};
					})
				);
			}),
			tap(async progress => {
				await publishEventFunc(PlatformCommunicationEvents.IosimProgressResult,
					[publisher], progress);
			}),
			take(1)
		).subscribe();
	}
}